import { createQueryKeyStore } from "@lukemorales/query-key-factory"

export default createQueryKeyStore({
  events: {
    list: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
    listPage: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
    calendarPage: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
    mapPage: ({
      searchValue,
      filter,
      petFriendly,
      ageRange,
      price,
      bounds,
    }: {
      searchValue: string
      filter: string[]
      petFriendly: string
      ageRange: string
      price: string
      bounds?: {
        north: number
        south: number
        east: number
        west: number
      }
    }) => ({
      queryKey: [{ searchValue, filter, petFriendly, ageRange, price, bounds }],
    }),
    types: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
    detail: (id: number) => ({
      queryKey: [id],
    }),
  },
  attractions: {
    list: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
    listTypes: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
  },
  advertisements: {
    list: ({ filters }: Record<string, unknown>) => ({
      queryKey: [{ filters }],
    }),
    images: () => ({ queryKey: ["images"] }),
    slots: () => ({ queryKey: ["slots"] }),
  },
  users: {
    me: () => ({
      queryKey: ["me"],
    }),
  },
})
